module.exports = __webpack_public_path__ + "assets/img/arrow.svg";